import styled from 'styled-components';
import { ReactComponent as ColorPickIcon } from 'assets/images/SVG/icons/colorpicker-icon.svg';
import { ReactComponent as RoundUpload } from 'assets/images/SVG/icons/upload-round-icon.svg';

export const ThemeCreatePageWrap = styled.div`
  .ant-input {
    width: 150px !important;
  }
  width: 100%;
  margin: 30px;
  padding: 20px;
  margin-top: 10px;
  padding-top: 5px;
`;
export const ColorPickerWrap = styled.div`
  display: flex;
  flex-direction: column-reverse;
`;
export const ThemeColorPickWrap = styled.div`
  display: flex;
  margin-bottom: 24px;
  align-items: flex-start;
  @media (max-width: 750px) {
    & {
      align-items: normal;
    }
  }

  .ant-form-item {
    margin-bottom: 0px;
  }

  .ant-upload-list.ant-upload-list-picture-card .ant-upload-list-item {
    padding: 8px;
  }
  .ant-upload.ant-upload-select {
    height: 30px !important;
    width: auto !important;
    border: none !important;
    color: var(--bg-button-default-color);
    display: flex;
  }
  .ant-upload-list-item-action {
    display: none;
  }

  &.backgroundimage {
    flex-wrap: wrap;
    .ant-upload-list.ant-upload-list-picture-card {
      display: flex;
      flex-direction: column-reverse;
      justify-content: flex-end;
    }
    .ant-upload-list-item-image {
      object-fit: cover !important;
    }

    .ant-upload-list-item-container {
      height: 180px !important;
      width: 300px !important;
    }
  }
  &.favicon {
    .ant-upload-list.ant-upload-list-picture-card {
      display: flex;
      flex-direction: row-reverse;
    }
    .ant-upload-list-item-container {
      height: 70px !important;
      width: 80px !important;
    }
  }
  &.logo {
    .ant-upload-list.ant-upload-list-picture-card {
      display: flex;
      flex-direction: row-reverse;
    }
    .ant-upload-list-item-container {
      height: 80px !important;
      width: 300px !important;
    }
    .object-fit-none .ant-upload-list-item-image {
      object-fit: none !important;
    }
    .object-fit-fill .ant-upload-list-item-image {
      object-fit: scale-down !important;
    }
    .logoinfo {
      max-width: 350px;
      text-align: center;
      margin-left: 20px;
      width: 100%;
    }
  }
`;
export const ThemeColorPickerIcon = styled(ColorPickIcon)`
  cursor: pointer;
  position: relative;
  top: 0;
  right: 0;
  margin-left: 10px;
`;
export const ImageUploadLoaderWrap = styled.div`
  width: 300px;
  display: flex;
  justify-content: center;
  max-height: 80px;
  padding-top: 10px;
`;
export const CreateHeadWrap = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;
export const CreateHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
export const SelectedName = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: gray;
`;
export const CreateLoginPart = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  @media (max-width: 800px) {
    & {
      display: flex;
      flex-direction: column;
      gap: 0;
    }
  }
`;
export const CreateLoginFormLeft = styled.div`
  display: grid;
  justify-content: start;
  justify-items: end;
  margin-top: 15px;
`;
export const CreateDisplayFlex = styled.div`
  display: flex;
  margin-bottom: 0px;
  flex-wrap: wrap;
  justify-content: space-between;
`;
export const CreatePageSubmitWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;
export const RoundUploadIcon = styled(RoundUpload)`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  fill: var(--bg-button-default-color);
  margin-top: 5px;
`;
